import React, {useState} from 'react';
import {Drawer} from "antd";
import {PlusOutlined} from '@ant-design/icons';

import './styles.scss';
import Button from "../../common/Button/Button";
import QuestionForm from "./QuestionForm";

interface Props {
    className?: string,
    onSubmit?: (values: string) => void,
}

function QuestionFormModalAsButton(props:Props){
    const {className, onSubmit} = props;
    const [showForm, setShowForm] = useState(false);

    const onButtonClick = async (e: any) => {
        e.stopPropagation();
        setShowForm(true);
    }

    const onFormSubmit = async (values: any) => {
        if (onSubmit) await onSubmit(values);
        setShowForm(false);
    }

    return (
        <div onClick={e => e.stopPropagation()}>
            <Button icon={<PlusOutlined/>} className={className} onClick={onButtonClick}>
                Create Question
            </Button>
            <Drawer title='Create Question' width='50%' keyboard={false} open={showForm} destroyOnClose onClose={()=>setShowForm(false)}
                    className='questions-form-drawer' footer={null}>
                <QuestionForm applyDrawerStyles onSubmit={onFormSubmit}/>
            </Drawer>
        </div>
    )
}

export default QuestionFormModalAsButton;